import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    cancel: 'Cancel',
    noResults: 'No results found.',
    suggestNewAsset: 'Request an asset to be listed by emailing our Client Success Team at',
    searchResults: 'Search Results',
    productTypes: 'Product Types'
  },
  de: {
    cancel: 'Abbrechen',
    noResults: 'Keine Ergebnisse gefunden.',
    suggestNewAsset:
      'Fordern Sie die Aufnahme eines Vermögenswerts an, indem Sie eine E-Mail an unser Client Success Team senden unter',
    searchResults: 'Search Results',
    productTypes: 'Product Types'
  },
});
